import CustomerAccount from '../../types/models/customerAccount';
import { exists } from '../../utils/util';

export const hasSalesRepresentative = (account?: CustomerAccount | null) => {
  if (!account) {
    return false;
  }
  return exists(account.sales_representative);
};
